export const COMPANY_NAME = "DSP Strategies LLC";
export const COMPANY_SHORT = "DSP Strategies";
export const COMPANY_INITIALS = "DS";
export const COMPANY_ADDRESS_FULL = "3490 Cinnamon Ridge Rd, San Ramon, California, US 94582-3270";
export const COMPANY_LOCATION = "San Ramon, California";
export const COMPANY_REGION = "San Ramon, California";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=3490%20Cinnamon%20Ridge%20Rd%2C%20San%20Ramon%2C%20California%2C%20US%2094582-3270";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Profile", "value": "Public directory" },
  { "label": "Region", "value": "San Ramon, California" },
  { "label": "Location", "value": "San Ramon, California" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "DSP Strategies LLC" },
  { "label": "City / State", "value": "San Ramon, California" },
  { "label": "Address", "value": "3490 Cinnamon Ridge Rd, San Ramon, California, US 94582-3270" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Organization", "body": "A concise public profile for DSP Strategies LLC." },
  { "icon": "✦", "title": "Location", "body": "Based in San Ramon, California." },
  { "icon": "✿", "title": "Directory details", "body": "Core organization and address information in one place." },
  { "icon": "❍", "title": "Visit", "body": "Use the map link for the listed public address." },
];
